/* eslint-disable react/jsx-key */
import { useGetOrganizations } from 'features/services/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Column } from 'react-table';
import { stringDateToLocaleString } from 'utils/dateUtils';

import { Table, TableCellChevronRight } from '../generic/Table';
import { OrganizationInfoDto } from '../services/apiGenerated';

export type OrganizationOverviewItem = OrganizationInfoDto;

export const OrganizationsTable = () => {
  const { t } = useTranslation();
  const { data, error, isLoading } = useGetOrganizations();

  const onRowClick = (row: OrganizationOverviewItem) => {
    navigate(`/management/organizations/${row.id}`);
  };

  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/ban-types
  const columns: Column<OrganizationOverviewItem>[] = [
    {
      Header: t('Bedrijfsnaam').toString(),
      accessor: 'name',
    },
    {
      Header: t('Afdelingen').toString(),
      accessor: 'departmentCount',
    },
    {
      Header: t('Medewerkers').toString(),
      accessor: 'employeeCount',
    },
    {
      Header: t('Rapportages').toString(),
      accessor: 'reportCount',
    },
    {
      Header: t('Documenten').toString(),
      accessor: 'documentCount',
    },
    {
      Header: t('Laatste wijziging').toString(),
      accessor: (row) => {
        if (!row.lastModifiedDate) {
          return '';
        }

        return stringDateToLocaleString(row.lastModifiedDate);
      },
      sortType: (rowA, rowB) => {
        if (rowA.original.lastModifiedDate === undefined) return 0;
        if (rowB.original.lastModifiedDate === undefined) return 1;
        if (new Date(rowA.original.lastModifiedDate) > new Date(rowB.original.lastModifiedDate)) return 1;
        if (new Date(rowB.original.lastModifiedDate) > new Date(rowA.original.lastModifiedDate)) return -1;
        return 0;
      },
    },
    {
      Header: t('Aangemaakt').toString(),
      accessor: (row) => {
        if (!row.creationDate) {
          return '';
        }
        return stringDateToLocaleString(row.creationDate);
      },
      sortType: (rowA, rowB) => {
        if (rowA.original.creationDate === undefined) return 0;
        if (rowB.original.creationDate === undefined) return 1;
        if (new Date(rowA.original.creationDate) > new Date(rowB.original.creationDate)) return 1;
        if (new Date(rowB.original.creationDate) > new Date(rowA.original.creationDate)) return -1;
        return 0;
      },
    },
    // {
    //   Header: t('Actief').toString(),
    //   accessor: (row) => (row.isActive ? TableCellActiveIcon : TableCellInactiveIcon),
    // },
    {
      Header: ' ',
      accessor: () => TableCellChevronRight,
    },
  ];

  return (
    <div>
      <Table columns={columns} data={data ?? []} error={error} onRowClick={onRowClick} isLoading={isLoading} />
    </div>
  );
};
